// Blue Theme Assets
// Model Images - Blue Theme
import chinaModelBlue from '../assets/themes/blue/images/model/china-model.png?url'
import usaModelBlue from '../assets/themes/blue/images/model/usa-model.png?url'
import egyptModelBlue from '../assets/themes/blue/images/model/egypt-model.png?url'
import germanyModelBlue from '../assets/themes/blue/images/model/germany-model.png?url'
import indiaModelBlue from '../assets/themes/blue/images/model/india-model.png?url'
import japanModelBlue from '../assets/themes/blue/images/model/japan-model.png?url'
import koreaModelBlue from '../assets/themes/blue/images/model/korea-model.png?url'
import laosModelBlue from '../assets/themes/blue/images/model/laos-model.png?url'
import malaysiaModelBlue from '../assets/themes/blue/images/model/malaysia-model.png?url'
import russiaModelBlue from '../assets/themes/blue/images/model/russia-model.png?url'
import singaporeModelBlue from '../assets/themes/blue/images/model/singapore-model.png?url'
import taiwanModelBlue from '../assets/themes/blue/images/model/taiwan-model.png?url'
import thailandModelBlue from '../assets/themes/blue/images/model/thailand-model.png?url'
import vietnamModelBlue from '../assets/themes/blue/images/model/vietnam-model.png?url'
import hangsengModelBlue from '../assets/themes/blue/images/model/hangseng-model.png?url'
import englandModelBlue from '../assets/themes/blue/images/model/england-model.png?url'
import maltaModelBlue from '../assets/themes/blue/images/model/malta-model.png?url'
import yeekeeModelBlue from '../assets/themes/blue/images/model/yeekee-model.png?url'

// Loading Screen Assets - Blue Theme
import loadingScreenBg1Blue from '../assets/themes/blue/images/loadingscreen/loading1_bg.jpg?url'
import loadingScreenBg2Blue from '../assets/themes/blue/images/loadingscreen/loading2_bg.jpg?url'
import loadingScreenBg3Blue from '../assets/themes/blue/images/loadingscreen/loading3_bg.jpg?url'

// SVG Assets - Blue Theme
import error404LightBlue from '../assets/themes/blue/images/svg/404/error_404_light.svg?url'
import error404DarkBlue from '../assets/themes/blue/images/svg/404/error_404_dark.svg?url'
import noDataLightBlue from '../assets/themes/blue/images/svg/NoDataAvailable/no_data_available_light.svg?url'
import noDataDarkBlue from '../assets/themes/blue/images/svg/NoDataAvailable/no_data_available_dark.svg?url'
import logoLightBlue from '../assets/themes/blue/images/logo/logo_light.svg?url'
import logoDarkBlue from '../assets/themes/blue/images/logo/logo_dark.svg?url'

// Flag Assets - Small Flags - Blue Theme
import thailandFlagBlue from '../assets/themes/blue/images/flag/small-flag/thailand-flag.png?url'
import usaFlagBlue from '../assets/themes/blue/images/flag/small-flag/usa-flag.png?url'
import mmFlagBlue from '../assets/themes/blue/images/flag/small-flag/myanmar-flag.png?url'
import chinaFlagBlue from '../assets/themes/blue/images/flag/small-flag/china-flag.png?url'
import egyptFlagBlue from '../assets/themes/blue/images/flag/small-flag/egypt-flag.png?url'
import germanyFlagBlue from '../assets/themes/blue/images/flag/small-flag/germany-flag.png?url'
import indiaFlagBlue from '../assets/themes/blue/images/flag/small-flag/india-flag.png?url'
import japanFlagBlue from '../assets/themes/blue/images/flag/small-flag/japan-flag.png?url'
import koreaFlagBlue from '../assets/themes/blue/images/flag/small-flag/korea-flag.png?url'
import laosFlagBlue from '../assets/themes/blue/images/flag/small-flag/laos-flag.png?url'
import malaysiaFlagBlue from '../assets/themes/blue/images/flag/small-flag/malaysia-flag.png?url'
import russiaFlagBlue from '../assets/themes/blue/images/flag/small-flag/russia-flag.png?url'
import singaporeFlagBlue from '../assets/themes/blue/images/flag/small-flag/singapore-flag.png?url'
import taiwanFlagBlue from '../assets/themes/blue/images/flag/small-flag/taiwan-flag.png?url'
import vietnamFlagBlue from '../assets/themes/blue/images/flag/small-flag/vietnam-flag.png?url'
import hangsengFlagBlue from '../assets/themes/blue/images/flag/small-flag/hangseng-flag.png?url'
import englandFlagBlue from '../assets/themes/blue/images/flag/small-flag/england-flag.png?url'
import maltaFlagBlue from '../assets/themes/blue/images/flag/small-flag/malta-flag.png?url'
import cambodiaFlagBlue from '../assets/themes/blue/images/flag/small-flag/camboadia-flag.png?url'

// Flag Assets - Background Flags - Blue Theme
import thailandFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/thailand-flag-bg.jpg?url'
import chinaFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/china-flag-bg.jpg?url'
import hangsengFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/hangseng-flag-bg.jpg?url'
import japanFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/japan-flag-bg.jpg?url'
import koreaFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/korea-flag-bg.jpg?url'
import laosFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/laos-flag-bg.jpg?url'
import malaysiaFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/malaysia-flag-bg.jpg?url'
import vietnamFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/vietnam-flag-bg.jpg?url'
import singaporeFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/singapore-flag-bg.jpg?url'
import indiaFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/india-flag-bg.jpg?url'
import germanyFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/germany-flag-bg.jpg?url'
import russiaFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/russia-flag-bg.jpg?url'
import egyptFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/egypt-flag-bg.jpg?url'
import englandFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/england-flag-bg.jpg?url'
import usaFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/usa-flag-bg.jpg?url'
import taiwanFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/taiwan-flag-bg.jpg?url'
import maltaFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/malta-flag-bg.jpg?url'
import stockFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/stock-flag-bg.jpg?url'
import baacFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/baac-flag-bg.jpg?url'
import aomsinFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/aomsin-flag-bg.jpg?url'
import cryptoFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/crypto-flag-bg.jpg?url'
import yeekeeVipFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/yeekee-vip-flag-bg.jpg?url'
import yeekeeFlagBgBlue from '../assets/themes/blue/images/flag/background-flag/yeekee-flag-bg.jpg?url'

// Flag Assets - Banner Flags - Blue Theme
import aomsinBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/aomsin-banner-flag.jpg?url'
import chinaAfternoonStockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/china-afternoon-stock-banner-flag.jpg?url'
import chinaMorningStockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/china-morning-stock-banner-flag.jpg?url'
import dowjonesBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/dowjones-banner-flag.jpg?url'
import egyptBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/egypt-banner-flag.jpg?url'
import englandBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/england-banner-flag.jpg?url'
import germanyBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/germany-banner-flag.jpg?url'
import hangsengBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/hangseng-banner-flag.jpg?url'
import hangsengMorningStockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/hangseng-morning-stock-banner-flag.jpg?url'
import hangsengAfternoonStockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/hangseng-afternoon-stock-banner-flag.jpg?url'
import indiaBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/india-banner-flag.jpg?url'
import japanBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/japan-banner-flag.jpg?url'
import nikkeiMorningStockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/nikkei-morning-stock-banner-flag.jpg?url'
import koreaBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/korea-banner-flag.jpg?url'
import laosBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/laos-banner-flag.jpg?url'
import malaysiaBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/malaysia-banner-flag.jpg?url'
import nikkeiAfternoonStockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/nikkei-afternoon-stock-banner-flag.jpg?url'
import russiaBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/russia-banner-flag.jpg?url'
import singaporeBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/singapore-banner-flag.jpg?url'
import taiwanBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/taiwan-banner-flag.jpg?url'
import thaiAfternoonStockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/thai-afternoon-stock-banner-flag.jpg?url'
import thaiGovernmentBankBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/thai-government-bank-banner-flag.jpg?url'
import thaiGovernmentBankSetBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/thai-government-bank-set-banner-flag.jpg?url'
import thaiGovernmentBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/thai-government-banner-flag.jpg?url'
import thaiGovernmentSetBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/thai-government-set-banner-flag.jpg?url'
import governmentSetLotteryBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/government-set-lottery-banner-flag.jpg?url'
import laosGroupSetBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/laos-group-set-banner-flag.jpg?url'
import thaiMorningStockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/thai-morning-stock-banner-flag.jpg?url'
import usaBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/usa-banner-flag.jpg?url'
import vietnamBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/vietnam-banner-flag.jpg?url'
import yeekeeBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/yeekee-banner-flag.jpg?url'
import yeekeeMaltaBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/yeekee-malta-banner-flag.jpg?url'
import baacBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/baac-banner-flag.jpg?url'
import stockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/stock-banner-flag.jpg?url'
import yeekeeVipBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/yeekee-vip-banner-flag.jpg?url'
import cryptoBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/crypto-banner-flag.jpg?url'
import governmentSavingsBankBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/government-savings-bank-banner-flag.jpg?url'
import hanoiBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/hanoi-banner-flag.jpg?url'
import hanoiVipBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/hanoi-vip-banner-flag.jpg?url'
import hanoiSpecialBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/hanoi-special-banner-flag.jpg?url'
import laostarBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/laostar-banner-flag.jpg?url'
import laoStarStockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/lao-star-stock-banner-flag.jpg?url'
import malaysiaStockBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/malaysia-stock-banner-flag.jpg?url'
import thaiStockEveningBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/thai-stock-evening-banner-flag.jpg?url'
import thaiStockPmBannerFlagBlue from '../assets/themes/blue/images/flag/banner-flag/thai-stock-pm-banner-flag.jpg?url'

// Banner Flag Assets - Thai Version - Blue Theme
import aomsinBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/aomsin-banner-flag.jpg?url'
import chinaAfternoonStockBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/china-afternoon-stock-banner-flag.jpg?url'
import chinaMorningStockBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/china-morning-stock-banner-flag.jpg?url'
import dowjonesBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/dowjones-banner-flag.jpg?url'
import egyptBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/egypt-banner-flag.jpg?url'
import englandBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/england-banner-flag.jpg?url'
import germanyBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/germany-banner-flag.jpg?url'
import governmentSavingsBankBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/government-savings-bank-banner-flag.jpg?url'
import governmentSetLotteryBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/government-set-lottery-banner-flag.jpg?url'
import hangsengAfternoonStockBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/hangseng-afternoon-stock-banner-flag.jpg?url'
import hangsengBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/hangseng-banner-flag.jpg?url'
import hangsengMorningStockBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/hangseng-morning-stock-banner-flag.jpg?url'
import hanoiBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/hanoi-banner-flag.jpg?url'
import indiaBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/india-banner-flag.jpg?url'
import japanBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/japan-banner-flag.jpg?url'
import koreaBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/korea-banner-flag.jpg?url'
import laoStarStockBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/lao-star-stock-banner-flag.jpg?url'
import laosBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/laos-banner-flag.jpg?url'
import laosGroupSetBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/laos-group-set-banner-flag.jpg?url'
import laostarBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/laostar-banner-flag.jpg?url'
import malaysiaBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/malaysia-banner-flag.jpg?url'
import malaysiaStockBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/malaysia-stock-banner-flag.jpg?url'
import nikkeiAfternoonStockBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/nikkei-afternoon-stock-banner-flag.jpg?url'
import nikkeiMorningStockBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/nikkei-morning-stock-banner-flag.jpg?url'
import russiaBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/russia-banner-flag.jpg?url'
import singaporeBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/singapore-banner-flag.jpg?url'
import taiwanBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/taiwan-banner-flag.jpg?url'
import thaiAfternoonStockBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/thai-afternoon-stock-banner-flag.jpg?url'
import thaiGovernmentBankBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/thai-government-bank-banner-flag.jpg?url'
import thaiGovernmentBankSetBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/thai-government-bank-set-banner-flag.jpg?url'
import thaiGovernmentBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/thai-government-banner-flag.jpg?url'
import thaiGovernmentSetBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/thai-government-set-banner-flag.jpg?url'
import thaiMorningStockBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/thai-morning-stock-banner-flag.jpg?url'
import thaiStockEveningBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/thai-stock-evening-banner-flag.jpg?url'
import thaiStockPmBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/thai-stock-pm-banner-flag.jpg?url'
import usaBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/usa-banner-flag.jpg?url'
import vietnamBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/vietnam-banner-flag.jpg?url'
import yeekeeBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/yeekee-banner-flag.jpg?url'
import yeekeeMaltaBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/yeekee-malta-banner-flag.jpg?url'
import yeekeeVipBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/yeekee-vip-banner-flag.jpg?url'
import hanoiVipBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/hanoi-vip-banner-flag.jpg?url'
import hanoiSpecialBannerFlagBlueTh from '../assets/themes/blue/images/flag/banner-flag-th/hanoi-special-banner-flag.jpg?url'

export const modelImageUrlsBlue: Record<string, string> = {
  china: chinaModelBlue,
  usa: usaModelBlue,
  egypt: egyptModelBlue,
  germany: germanyModelBlue,
  india: indiaModelBlue,
  japan: japanModelBlue,
  korea: koreaModelBlue,
  laos: laosModelBlue,
  malaysia: malaysiaModelBlue,
  russia: russiaModelBlue,
  singapore: singaporeModelBlue,
  taiwan: taiwanModelBlue,
  thailand: thailandModelBlue,
  vietnam: vietnamModelBlue,
  hangseng: hangsengModelBlue,
  england: englandModelBlue,
  malta: maltaModelBlue,
  yeekee: yeekeeModelBlue,
}

export const LOADING_ASSETS_BLUE = {
  background: loadingScreenBg1Blue, // Default fallback
  backgrounds: {
    bg1: loadingScreenBg1Blue,
    bg2: loadingScreenBg2Blue,
    bg3: loadingScreenBg3Blue,
  },
} as const

export const SVG_ASSETS_BLUE = {
  ERROR_404: {
    light: error404LightBlue,
    dark: error404DarkBlue,
  },
  NO_DATA: {
    light: noDataLightBlue,
    dark: noDataDarkBlue,
  },
  LOGO: {
    light: logoLightBlue,
    dark: logoDarkBlue,
  },
} as const

// Small Flag Assets - Blue Theme
export const smallFlagImageUrlsBlue: Record<string, string> = {
  china: chinaFlagBlue,
  egypt: egyptFlagBlue,
  germany: germanyFlagBlue,
  india: indiaFlagBlue,
  japan: japanFlagBlue,
  korea: koreaFlagBlue,
  laos: laosFlagBlue,
  malaysia: malaysiaFlagBlue,
  russia: russiaFlagBlue,
  singapore: singaporeFlagBlue,
  taiwan: taiwanFlagBlue,
  thailand: thailandFlagBlue,
  usa: usaFlagBlue,
  vietnam: vietnamFlagBlue,
  hangseng: hangsengFlagBlue,
  england: englandFlagBlue,
  malta: maltaFlagBlue,
  mm: mmFlagBlue,
  cambodia: cambodiaFlagBlue,
  // Legacy country codes for backward compatibility
  th: thailandFlagBlue,
  en: usaFlagBlue,
}

// Background Flag Assets - Blue Theme
export const backgroundFlagImageUrlsBlue: Record<string, string> = {
  thailand: thailandFlagBgBlue,
  china: chinaFlagBgBlue,
  hangseng: hangsengFlagBgBlue,
  japan: japanFlagBgBlue,
  korea: koreaFlagBgBlue,
  laos: laosFlagBgBlue,
  malaysia: malaysiaFlagBgBlue,
  vietnam: vietnamFlagBgBlue,
  'hanoi-vip': vietnamFlagBgBlue,
  'hanoi-special': vietnamFlagBgBlue,
  singapore: singaporeFlagBgBlue,
  india: indiaFlagBgBlue,
  germany: germanyFlagBgBlue,
  russia: russiaFlagBgBlue,
  egypt: egyptFlagBgBlue,
  england: englandFlagBgBlue,
  usa: usaFlagBgBlue,
  taiwan: taiwanFlagBgBlue,
  malta: maltaFlagBgBlue,
  stock: stockFlagBgBlue,
  baac: baacFlagBgBlue,
  aomsin: aomsinFlagBgBlue,
  crypto: cryptoFlagBgBlue,
  'yeekee-vip': yeekeeVipFlagBgBlue,
  yeekee: yeekeeFlagBgBlue,
  gsb: aomsinFlagBgBlue, // Same as aomsin
}

// Banner Flag Assets - Blue Theme
export const bannerFlagImageUrlsBlue: Record<string, string> = {
  'aomsin-lotto': aomsinBannerFlagBlue,
  'china-afternoon-stock': chinaAfternoonStockBannerFlagBlue,
  'china-morning-stock': chinaMorningStockBannerFlagBlue,
  'dowjones-stock': dowjonesBannerFlagBlue,
  'egypt-stock': egyptBannerFlagBlue,
  'england-stock': englandBannerFlagBlue,
  'german-stock': germanyBannerFlagBlue,
  hangseng: hangsengBannerFlagBlue,
  'hangseng-morning-stock': hangsengMorningStockBannerFlagBlue,
  'hangseng-afternoon-stock': hangsengAfternoonStockBannerFlagBlue,
  'india-lotto': indiaBannerFlagBlue,
  'japan-lotto': japanBannerFlagBlue,
  'nikkei-morning-stock': nikkeiMorningStockBannerFlagBlue,
  'korea-stock': koreaBannerFlagBlue,
  'laos-lotto': laosBannerFlagBlue,
  'malaysia-lotto': malaysiaBannerFlagBlue,
  'nikkei-afternoon-stock': nikkeiAfternoonStockBannerFlagBlue,
  'russia-stock': russiaBannerFlagBlue,
  'singapore-stock': singaporeBannerFlagBlue,
  'taiwan-stock': taiwanBannerFlagBlue,
  'thai-afternoon-stock': thaiAfternoonStockBannerFlagBlue,
  'thai-government-bank': thaiGovernmentBankBannerFlagBlue,
  'thai-government-bank-set': thaiGovernmentBankSetBannerFlagBlue,
  'thai-government': thaiGovernmentBannerFlagBlue,
  'thai-government-set': thaiGovernmentSetBannerFlagBlue,
  'government-set-lottery': governmentSetLotteryBannerFlagBlue,
  'laos-group-set': laosGroupSetBannerFlagBlue,
  // Additional mappings for different naming conventions
  'thai-government-bank-lotto': thaiGovernmentBankBannerFlagBlue,
  'thai-government-bank-banner-flag': thaiGovernmentBankBannerFlagBlue,
  'thai-government-bank-lotto-set': thaiGovernmentBankSetBannerFlagBlue,
  'thai-government-lotto': thaiGovernmentBannerFlagBlue,
  'thai-government-lotto-set': thaiGovernmentSetBannerFlagBlue,
  'laos-group-set-banner-flag': laosGroupSetBannerFlagBlue,
  'thai-morning-stock': thaiMorningStockBannerFlagBlue,
  'usa-stock': usaBannerFlagBlue,
  'vietnam-lotto': vietnamBannerFlagBlue,
  yeekee: yeekeeBannerFlagBlue,
  'yeekee-malta': yeekeeMaltaBannerFlagBlue,
  'baac-lotto': baacBannerFlagBlue,
  stock: stockBannerFlagBlue,
  'yeekee-vip': yeekeeVipBannerFlagBlue,
  crypto: cryptoBannerFlagBlue,
  'government-savings-bank': governmentSavingsBankBannerFlagBlue,
  hanoi: hanoiBannerFlagBlue,
  'hanoi-vip': hanoiVipBannerFlagBlue,
  'hanoi-special': hanoiSpecialBannerFlagBlue,
  laostar: laostarBannerFlagBlue,
  'lao-star-stock': laoStarStockBannerFlagBlue,
  'malaysia-stock': malaysiaStockBannerFlagBlue,
  'thai-stock-evening': thaiStockEveningBannerFlagBlue,
  'thai-stock-pm': thaiStockPmBannerFlagBlue,
}

export const bannerFlagImageUrlsBlueTh: Record<string, string> = {
  'aomsin-lotto': aomsinBannerFlagBlueTh,
  'china-afternoon-stock': chinaAfternoonStockBannerFlagBlueTh,
  'china-morning-stock': chinaMorningStockBannerFlagBlueTh,
  'dowjones-stock': dowjonesBannerFlagBlueTh,
  'egypt-stock': egyptBannerFlagBlueTh,
  'england-stock': englandBannerFlagBlueTh,
  'german-stock': germanyBannerFlagBlueTh,
  hangseng: hangsengBannerFlagBlueTh,
  'hangseng-morning-stock': hangsengMorningStockBannerFlagBlueTh,
  'hangseng-afternoon-stock': hangsengAfternoonStockBannerFlagBlueTh,
  'india-lotto': indiaBannerFlagBlueTh,
  'japan-lotto': japanBannerFlagBlueTh,
  'nikkei-morning-stock': nikkeiMorningStockBannerFlagBlueTh,
  'korea-stock': koreaBannerFlagBlueTh,
  'laos-lotto': laosBannerFlagBlueTh,
  'malaysia-lotto': malaysiaBannerFlagBlueTh,
  'nikkei-afternoon-stock': nikkeiAfternoonStockBannerFlagBlueTh,
  'russia-stock': russiaBannerFlagBlueTh,
  'singapore-stock': singaporeBannerFlagBlueTh,
  'taiwan-stock': taiwanBannerFlagBlueTh,
  'thai-afternoon-stock': thaiAfternoonStockBannerFlagBlueTh,
  'thai-government-bank': thaiGovernmentBankBannerFlagBlueTh,
  'thai-government-bank-set': thaiGovernmentBankSetBannerFlagBlueTh,
  'thai-government': thaiGovernmentBannerFlagBlueTh,
  'thai-government-set': thaiGovernmentSetBannerFlagBlueTh,
  'government-set-lottery': governmentSetLotteryBannerFlagBlueTh,
  'laos-group-set': laosGroupSetBannerFlagBlueTh,
  // Additional mappings for different naming conventions
  'thai-government-bank-lotto': thaiGovernmentBankBannerFlagBlueTh,
  'thai-government-bank-banner-flag': thaiGovernmentBankBannerFlagBlueTh,
  'thai-government-bank-lotto-set': thaiGovernmentBankSetBannerFlagBlueTh,
  'thai-government-lotto': thaiGovernmentBannerFlagBlueTh,
  'thai-government-lotto-set': thaiGovernmentSetBannerFlagBlueTh,
  'laos-group-set-banner-flag': laosGroupSetBannerFlagBlueTh,
  'thai-morning-stock': thaiMorningStockBannerFlagBlueTh,
  'usa-stock': usaBannerFlagBlueTh,
  'vietnam-lotto': vietnamBannerFlagBlueTh,
  yeekee: yeekeeBannerFlagBlueTh,
  'yeekee-malta': yeekeeMaltaBannerFlagBlueTh,
  'yeekee-vip': yeekeeVipBannerFlagBlueTh,
  'government-savings-bank': governmentSavingsBankBannerFlagBlueTh,
  hanoi: hanoiBannerFlagBlueTh,
  'hanoi-vip': hanoiVipBannerFlagBlueTh,
  'hanoi-special': hanoiSpecialBannerFlagBlueTh,
  laostar: laostarBannerFlagBlueTh,
  'lao-star-stock': laoStarStockBannerFlagBlueTh,
  'malaysia-stock': malaysiaStockBannerFlagBlueTh,
  'thai-stock-evening': thaiStockEveningBannerFlagBlueTh,
  'thai-stock-pm': thaiStockPmBannerFlagBlueTh,
}
